import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const LogInIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18.984 2.6001C19.528 2.6001 20 2.8001 20.4 3.2001C20.8 3.6001 21 4.0721 21 4.6161V18.5841C21 19.1281 20.8 19.6001 20.4 20.0001C20 20.4001 19.528 20.6001 18.984 20.6001H5.016C4.456 20.6001 3.98 20.4001 3.588 20.0001C3.196 19.6001 3 19.1281 3 18.5841V14.6001H5.016V18.5841H18.984V4.6161H5.016V8.6001H3V4.6161C3 4.0721 3.196 3.6001 3.588 3.2001C3.98 2.8001 4.456 2.6001 5.016 2.6001H18.984ZM10.08 15.2001L12.648 12.5841H3V10.6161H12.648L10.08 8.0001L11.496 6.5841L16.512 11.6001L11.496 16.6161L10.08 15.2001Z'
                fill='currentColor'
            />
        </>
    ),
})

LogInIcon.displayName = 'LogInIcon'
